import React, {useState, useEffect, useContext} from 'react'
import PatientContext from '../../../context/patientContext'
import UserPrefContext from "../../../context/userPrefContext"
import DictionaryContext from '../../../context/dictionaryContext'
import AuthContext from '../../../context/authContext'
import SynkinesisAssessmentOneChart from './SynkinesisAssessmentOneChart'
import TotalScore from '../shared/TotalScore'
import chartClasses from '../../stylesheets/Charts.module.css'

function SynkinesisAssessmentCharts(props) {

    const panelName = 'synkinesis_assessment_panel'
    const dictCtx = useContext(DictionaryContext)
    const visCtx = useContext(PatientContext)
    const userPrefCtx = useContext(UserPrefContext)
    const authCtx = useContext(AuthContext)
    const synkinesisGetAllURL = `${process.env.REACT_APP_SERVER}/api/v1/synkinesis_assessments/get_graphs/${visCtx.pat_token}`
    const [groups, setGroups] = useState([])
    const [synkinesisAssessments, setSynkinesisAseessments] = useState([])
    const [x_axis_categories, set_x_axis_categories] = useState([])


    const buildGroups = () => {
        const dictPanel = dictCtx.dict_panel.find(pnl => pnl.display_name_short === panelName)
        
        if (dictPanel !== undefined) {
            // find dict_intake_form by display_name_short:
            // display_name_short in dict_panle looks like "panelname_panel"
            // display_name_short in dict_intake_form looks like "panelname"
            // console.log("dictPanel", dictPanel)
            const intakeForm = dictCtx.dict_intake_form.find(form => {
                return form.display_name_short === dictPanel.display_name_short.replace("_panel","")
            })
        
            if (intakeForm !== undefined) {
                // console.log("intakeForm", intakeForm)
                // setIntakeFormId(intakeForm.id)
                // sort questions by sort_position
                const questions = dictCtx.dict_intake_form_question.filter(quest => {
                    return quest.DictIntakeFormQuestion.dict_intake_form_id === intakeForm.id
                })

                // console.log("questions", questions)
                
                const comp = (a,b) => {
                    var agrp = (+a.DictIntakeFormQuestion.group_id) * 100 + (+a.DictIntakeFormQuestion.sort_position)
                    var bgrp = (+b.DictIntakeFormQuestion.group_id) * 100 + (+b.DictIntakeFormQuestion.sort_position)
        
                    // console.log("sort:", typeof anum, typeof bnum, (anum - bnum))
                    return agrp - bgrp
                }
                // const sortedQuestions = questions.sort((a,b) => a.sort_position - b.sort_postion)
                const sortedQuestions = questions.sort(comp)
  
                // get group_ids of questions (only one id per group)
                // const groups = sortedQuestions
                //     .map((value, index, qs) => (index > 0 && qs[index-1].DictIntakeFormQuestion.group_id === value.DictIntakeFormQuestion.group_id) ? null : value.DictIntakeFormQuestion.group_id)
                //     .filter(value => value !== null)

                const charts = dictCtx
                    .dict_chart.filter(chart => chart.group_display_name_short === panelName.replace("_panel",""))
                    // .map(chart => {
                    //     console.log("chart.x_axis_category", chart.x_axis_category)
                    //     return {
                    //         questions: JSON.parse(chart.x_axis_category),
                    //         chart: chart,
                    // }})

                // console.log("charts", charts)

                const groups = charts.map(chart => chart.group_id)

// console.log("Groups built - groups",groups)

                // chart questions
                
                const chartQs = charts.map(chart => {
                    let groupQuestions = []
                    let y_categories = []
                    if (!!chart.x_axis_category && chart.x_axis_category.startsWith("[[")) {
                        try {
                            const x_categories = JSON.parse(chart.x_axis_category)
                            if (Array.isArray(x_categories) && x_categories.length > 0) {
                                groupQuestions = x_categories.map(cat => {
                                    const qname = cat[1]
                                    // console.log("qname, question", qname, questions.find(q => q.DictIntakeFormQuestion.display_name_short === qname))

                                    const valsString = questions.find(q => q.DictIntakeFormQuestion.display_name_short === qname)?.DictIntakeFormQuestion?.question_option_values
                                    const vals = JSON.parse(valsString)
                                    return {question: qname, title: cat[0], values: vals}
                                })
                            }
                            y_categories = JSON.parse(chart.y_axis_category)
                        }
                        catch (error) {
  
                        } 
                    }
                    return {...chart, questions: groupQuestions, y_categories: y_categories}
                })

                // console.log("Chart questions", chartQs)

                // build array of group objects: {group_id: 1, group_questions: [questions]}
                // const group_questions = groups.map((group_id) => {
                //     // const group_qs = sortedQuestions.filter((q) => q.group_id === group_id)
                //     return {
                //         group_id: group_id, 
                //         group_questions: sortedQuestions.filter((q) => q.DictIntakeFormQuestion.group_id === group_id), 
                //         chart: dictCtx.dict_chart
                //             .filter(chart => chart.group_display_name_short === panelName.replace("_panel",""))
                //             .find(chart => chart.group_id === group_id)
                //     }
                // })

                // const isQuestionInChartGroup = (question_name) => {

                // }

                // const group_questions = groups.map((group_id) => {
                //     // const group_qs = sortedQuestions.filter((q) => q.group_id === group_id)
                //     return {
                //         group_id: group_id, 
                //         group_questions: sortedQuestions.filter((q) => q.DictIntakeFormQuestion.display_name_short), 
                //         chart: dictCtx.dict_chart
                //             .filter(chart => chart.group_display_name_short === panelName.replace("_panel",""))
                //             .find(chart => chart.group_id === group_id)
                //     }
                // })


// console.log("Groups built - group_questions",group_questions)

                return chartQs.sort((a,b) => {
                    var agrp = (+a.group_id) 
                    var bgrp = (+b.group_id) 
        
                    // console.log("sort:", typeof anum, typeof bnum, (anum - bnum))
                    return agrp - bgrp
                })
            }
        }
        return []
    }

    const getSynkinesisData = async() => {
        try {
            const response = await fetch(synkinesisGetAllURL, {
                headers: {
                    'Authorization': `Bearer ${userPrefCtx.bearerToken}`,
                    auth: authCtx.authMode,
                },

            })
            
            if (response.status === 200) {
                // console.log("synkinesis charts response", response, ignoreSynkinesis)
                // if (!ignoreSynkinesis) {
                    const responseData = await response.json()
                    // sort data by created_at
                    const sorted_data = responseData.chart_data.sort((a,b) => new Date(a.created_at) > new Date(b.created_at) ? 1 : -1)
                    // console.log("Get synkinesis charts", sorted_data)
                    setSynkinesisAseessments(sorted_data)
                    if (props.mode === 'inline') {
                        // props.setLastLoadedTime(new Date().getTime())
                        props.refreshLastLoadedTime()
                    }
                // }
                
            } else {
                console.log("Failed to get all synkinesis data", response)
            }
        } catch (e) {
            console.log("Failed to get all synkinesis data", e)
        }

    }

    useEffect(() => {
            // console.log("**** SynkinesisAssessmentsCharts loading **** authCtx", authCtx)
            let ignoreSynkinesis = false
            // console.log("SynkinesisAssessmentCharts: props.lastUpdatedTime, props.lastLoadedTime", props.lastUpdatedTime, props.lastLoadedTime)
    
            // console.log("FaceInstrumentCharts: mode=", props.mode, "lastLoadedTime", props.lastLoadedTime, "lastUpdatedTime", props.lastUpdatedTime)
            // reload face instrument data only if either in 'dialog' mode or if data was updated AFTER it was loaded
            if ((props.mode === 'dialog' || (props.lastLoadedTime < props.lastUpdatedTime)) && userPrefCtx.bearerToken !== null && dictCtx.dict_panel.length > 0) {
    
                // console.log("Let's load face SynkinesisAssessmentCharts data")
                getSynkinesisData()
    
                // if in inline mode update loaded time
                // console.log("Synkinesis Assessment Charts props", props)
                // if (props.mode === 'inline') {
                //     props.setLastLoadedTime(new Date().getTime())
                // }
    
                // build groups
                const saGroups = buildGroups()
                // console.log("Synkinesis Charts - groups", saGroups)
                setGroups(saGroups)
                // console.log("fiGroups:", fiGroups)
        
                const x_categories = saGroups.map((grp) => {
                    const grp_cats = !!grp.x_axis_category ? JSON.parse(grp.x_axis_category) : []
                    // console.log("grp_cats", grp_cats)
                    return grp_cats
                })
                    
                // console.log("x_categories", x_categories)
                // each element in x_categories is a two-elemnt array; first alement is the name of the chart; second is the name of the corresponding value field in eface data
                set_x_axis_categories(x_categories)
            }
            
    
    
    
    
            // return () => {
            //     ignoreSynkinesis = true
            // }
    
        }, [userPrefCtx.bearerToken, props.lastUpdatedTime, props.lastLoadedTime, dictCtx.dict_panel.length, visCtx.pat_token])


    const chartsClicked = () => {
        if (synkinesisAssessments.length > 0 && props.hasOwnProperty('onClick')) {
            props.onClick()
        }
    }


    return (
        <div className={`face-instrument-charts ${props.viewType === 'full' ? chartClasses['charts-full']: chartClasses['charts-sm'] }`} height='300' 
            onClick={chartsClicked}
        >
            {props.viewType === 'full' && synkinesisAssessments.length > 0 &&
                <h3 className={chartClasses['charts-center']}>
                    Total Synkinesis Assessment Score: 
                    <TotalScore 
                        data={synkinesisAssessments}    
                        property_date_name='created_at'
                        property_value_name='saq_total_score'
                        first_or_last='first'
                    />
                </h3>
            }

            {
                groups.length > 0 && synkinesisAssessments.length > 0 && groups.map((grp, grp_ix) => {
                    // const group_title = grp.questions.length > 1 ? `${grp.questions[0].display_name_short}-${grp.group_questions[grp.questions.length-1].display_name_short}` : grp.questions[0]?.display_name_short
                    return (
                        !!grp.questions.length ?
                            <SynkinesisAssessmentOneChart 
                                key={grp_ix}
                                // chart_title={group_title}
                                // chart_title={grp.chart.chart_title}
                                group={grp}
                                data={synkinesisAssessments}
                                x_categories={grp.x_axis_category}
                                width={props.width}
                                viewType={props.viewType}
                                height={props.viewType === 'full' ? 500 : 100}
                            />
                            :
                            null
                    )   

                })
            }
        </div>
    )
}

export default SynkinesisAssessmentCharts
